<template>
  <div class="resume-more-wrapper">
    <div class="resume-more-container">
      <div class="more-item" @click="clickShareWx">
        <i class="iconfont iconqiepian"></i>发送到微信
      </div>
      <div class="more-item" @click="clickSendEmail">
        <i class="iconfont iconqiepianbeifen"></i>发送到邮箱
      </div>
      <div class="more-item" @click="clickMergeResume">
        <i class="iconfont iconhebingzhongyingwen"></i>合并中英文
      </div>
      <div v-if="!isMentor" class="more-item" @click="copyResume">
        <i class="iconfont iconfuzhi1"></i>复制简历
      </div>
      <div v-if="!isMentor" class="more-item" @click="clickDelete">
        <i class="iconfont iconshanchu1"></i>删除
      </div>
      <div v-if="!isMentor" class="more-item" @click="clickChangeTheme">
        <i
          class="iconfont"
          :class="
            personInfo.theme === 'dark' ? 'iconrijianmoshi' : 'iconyejianmoshi'
          "
        ></i>
        {{ personInfo.theme === "dark" ? "日间模式" : "暗夜模式" }}
      </div>
    </div>
  </div>
</template>
<script>
import { mapState } from "vuex";
export default {
  name: "ResumeMore",
  computed: {
    ...mapState("me", ["personInfo"]),
    isMentor() {
      return window.location.href.includes("mentor");
    },
  },
  methods: {
    clickChangeTheme() {
      this.$emit("clickChangeTheme");
    },
    copyResume() {
      this.$emit("copyResume");
    },
    clickMergeResume() {
      this.$emit("clickMergeResume");
    },
    clickShareWx() {
      this.$emit("clickShareWx");
    },
    clickSendEmail() {
      this.$emit("clickSendEmail");
    },
    clickDelete() {
      this.$emit("clickDelete");
    },
  },
};
</script>
<style lang="scss" scoped>
.resume-more-wrapper {
  padding-top: 6px;
}
.resume-more-container {
  background: linear-gradient(45deg, #272b33 0%, #272b33 62%, #523433 100%);
  border-radius: 8px;
  border: 1px solid #383e49;
  backdrop-filter: blur(8px);
  width: 170px;
  overflow: hidden;
  box-sizing: border-box;
  .more-item {
    position: relative;
    display: flex;
    align-items: center;
    height: 53px;
    padding: 0 24px;

    &:hover {
      background-color: rgba(255, 255, 255, 0.06);
    }
    .vip-icon {
      position: absolute;
      right: 10px;
      width: 22px;
    }
    .iconfont {
      font-size: 20px;
      margin-right: 16px;
    }
    &:nth-child(2),
    &:nth-child(4),
    &:nth-child(5) {
      &::after {
        content: "";
        display: inline-block;
        height: 1px;
        width: calc(100% - 48px);
        position: absolute;
        bottom: 0;
        left: 24px;
        background-color: rgba(255, 255, 255, 0.06);
      }
    }
  }
}
</style>
